/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetLastSelectedIdParameter } from './ApiUserTasksGetLastSelectedIdParameter';
import {
    ApiUserTasksGetLastSelectedIdParameterFromJSON,
    ApiUserTasksGetLastSelectedIdParameterFromJSONTyped,
    ApiUserTasksGetLastSelectedIdParameterToJSON,
    ApiUserTasksGetLastSelectedIdParameterToJSONTyped,
} from './ApiUserTasksGetLastSelectedIdParameter';

/**
 * 
 * @export
 * @interface CreateCalculationResponse
 */
export interface CreateCalculationResponse {
    /**
     * 
     * @type {ApiUserTasksGetLastSelectedIdParameter}
     * @memberof CreateCalculationResponse
     */
    id: ApiUserTasksGetLastSelectedIdParameter;
    /**
     * 
     * @type {string}
     * @memberof CreateCalculationResponse
     */
    name: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateCalculationResponse
     */
    entityId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateCalculationResponse
     */
    displayName?: string | null;
}

/**
 * Check if a given object implements the CreateCalculationResponse interface.
 */
export function instanceOfCreateCalculationResponse(value: object): value is CreateCalculationResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function CreateCalculationResponseFromJSON(json: any): CreateCalculationResponse {
    return CreateCalculationResponseFromJSONTyped(json, false);
}

export function CreateCalculationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCalculationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': ApiUserTasksGetLastSelectedIdParameterFromJSON(json['id']),
        'name': json['name'],
        'entityId': json['entityId'] == null ? undefined : json['entityId'],
        'displayName': json['displayName'] == null ? undefined : json['displayName'],
    };
}

export function CreateCalculationResponseToJSON(json: any): CreateCalculationResponse {
    return CreateCalculationResponseToJSONTyped(json, false);
}

export function CreateCalculationResponseToJSONTyped(value?: CreateCalculationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': ApiUserTasksGetLastSelectedIdParameterToJSON(value['id']),
        'name': value['name'],
        'entityId': value['entityId'],
        'displayName': value['displayName'],
    };
}

